import { AssertLogin } from '../../util/decorators';
import { AthomCloudAPI } from 'athom-api';
import { homey } from './homey/store';

let cloudAPI;

export const api = {
	namespaced: true,

	state: {
		user: null,
		loading: true,
	},

	getters: {
		authenticated(state) {
			return !!state.user
		},
		user(state) {
    		return state.user;
		},
	},

	mutations: {
		_setUser(state, { user }){
			state.user = user;
		},
		_clearAll(state){
			state.user = null;
		},
	},

	actions: {
		swapCodeForToken(state, {code}) {
			return cloudAPI.authenticateWithAuthorizationCode(code);
		},
		login(context, { token }) {
			return cloudAPI.setToken(token);
		},
		getLoginUrl() {
			return cloudAPI.getLoginUrl();
		},
		logout({ commit, dispatch }, excludeAPI = false){
			if(!excludeAPI) cloudAPI.logout();
			commit('_clearAll');
			Object.keys(api.modules).forEach(module => dispatch(`${module}/clearAll`));
		},

		getUser({ commit }){
			return cloudAPI.getAuthenticatedUser()
				.then(user => {
					commit('_setUser', { user });
				});
		},

		getCachedUser() {
			return cloudAPI.getAuthenticatedUserCached();
		}
	},

	modules: {
		homey,
	},

	plugins: [
		(store) => {

			const redirectUrl = `${window.location.protocol}//${window.location.host}/#/oauth2/callback`;
			cloudAPI = new AthomCloudAPI({
			  clientId: '5ab519dcd1f5642c0b9eb8e5',
			  clientSecret: 'yBfT5ydLyVg08Lh2UyXlJC1SPpOsUMZZDNCvSYm5',
			  redirectUrl: redirectUrl,
			});

			cloudAPI.on('logout', () => store.dispatch('api/logout', true));

			if(!store.state.api.user) {
				store.dispatch('api/getCachedUser').catch(e => {}).then(a => store.state.api.loading = true && store.dispatch('api/getUser')).catch(e => {});
			}
		},
	],
};
